<template>
  <section class="edit-policy-form width-700">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <travel-policy-form
        ref="policy-form"
        :form="form"
        :showBuyable="showBuyable"
        :isRequired="isRequired"
        :editType="editType"
        :isRefer="isRefer"
        :checkRefer="checkRefer"
        @getFormData="getFormData" />
    </el-form>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import travelPolicyForm from '@/views/quoting/modules/travel/form/travel-policy-form'

export default {
  name: 'editTravelPolicyForm',
  components: {
    travelPolicyForm
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        benefits: []
      }
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
            }
          })
        }
      }
    },
    // editType: {
    //   immediate: true,
    //   handler(val) {
    //     this.requireValid = val === 2? true: false
    //   }
    // },
  },
  methods: {
    submitForm(otherData = {}) {
      this.$refs['form'].validate(valid => {
        if(valid) {
          this.$refs['policy-form'].submitForm(otherData)
        }
      })

    },
    getFormData(data, otherData) {
      // 整合其他數據
      const result = {
        ...this.formData,
        ...data
      }
      this.$emit('getFormData', result, otherData)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
